import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=3182bcdb&scoped=true"
import script from "./Credit.vue?vue&type=script&lang=ts"
export * from "./Credit.vue?vue&type=script&lang=ts"
import style0 from "./Credit.vue?vue&type=style&index=0&id=3182bcdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3182bcdb",
  null
  
)

export default component.exports